// Kbd — 키보드 단축키 표시 (예: ⌘K, Ctrl+S, Del).
// 시맨틱 <kbd> 요소 사용.

import { type HTMLAttributes } from 'react';

export interface KbdProps extends HTMLAttributes<HTMLElement> {
  /** 키 텍스트 (children 대신 prop으로도 지원) */
  keys?: string | string[];
}

/**
 * Locker UI — Kbd
 * @example
 * <Kbd>⌘K</Kbd>
 * <Kbd keys={['Ctrl', 'S']} />
 */
export function Kbd({ keys, className = '', children, ...rest }: KbdProps) {
  const classes = ['ui-kbd', className].filter(Boolean).join(' ');

  if (keys) {
    const keyArr = Array.isArray(keys) ? keys : [keys];
    return (
      <span className="ui-kbd-combo">
        {keyArr.map((k, i) => (
          <span key={i}>
            {i > 0 && <span className="ui-kbd-plus">+</span>}
            <kbd className={classes} {...rest}>
              {k}
            </kbd>
          </span>
        ))}
      </span>
    );
  }

  return (
    <kbd className={classes} {...rest}>
      {children}
    </kbd>
  );
}
